import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/core';

const flash = () => {
  return keyframes`
    from {
      opacity: 1;
      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.5);
    }
    to {
      opacity: 1;
      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
    }
  `;
};

const baseStyles = ({ theme }) => css`
  background: ${theme.colors.white};
  width: 100%;
  min-height: 30px;
  min-width: 200px;
  position: relative;
`;

const animateStyles = ({ animate }) =>
  animate
    ? css`
        &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          width: 100%;
          height: 100%;
          opacity: 0;
          border-radius: 5px;
          animation: ${flash()} 2s ease-in 0s 1 normal forwards;
        }
      `
    : css`
        box-shadow: 0 2px 4px 0 rgba(172, 172, 172, 0.5);
      `;

const centeredStyles = ({ centered }) =>
  centered &&
  css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `;

const roundedStyles = ({ theme, rounded }) =>
  rounded &&
  css`
    border-radius: ${theme.borderRadius.giga};
  `;

const arrowStyles = ({ theme, arrow }) =>
  arrow &&
  css`
    &:after {
      content: ' ';
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid ${theme.colors.white};
      position: absolute;
      top: 5px;
      left: -10px;
    }
  `;

const arrowActiveStyles = ({ theme, arrow, active }) =>
  arrow &&
  active &&
  css`
    &:after {
      border-right-color: ${theme.colors.g300};
    }
  `;

const backgroundStyles = ({ background }) =>
  background &&
  css`
    background: ${background};
  `;

const ShadowBox = styled('div')(
  baseStyles,
  animateStyles,
  centeredStyles,
  roundedStyles,
  arrowStyles,
  arrowActiveStyles,
  backgroundStyles,
);

export default ShadowBox;
